import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import "vue-loading-overlay/dist/css/index.css"; // CSS do loader
import { LoadingPlugin } from "vue-loading-overlay"; // Plugin do loader
import { Toaster } from 'vue-sonner'
import 'vue-sonner/style.css'        // <<– CSS global
import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

const app = createApp(App);
app.use(LoadingPlugin);
app.component('Toaster', Toaster);
app.use(router);
app.use(PrimeVue);
app.mount('#app');
